import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcFaqH32(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.297 24.867a1.2 1.2 0 0 1 1.2 1.2v.012a1.2 1.2 0 0 1-2.4 0v-.012a1.2 1.2 0 0 1 1.2-1.2M21.802 17.25c-.869 0-1.617.401-2.058.987a.75.75 0 0 1-1.198-.902c.729-.969 1.924-1.585 3.256-1.585 2.147 0 3.986 1.626 3.986 3.75s-1.84 3.75-3.986 3.75a.75.75 0 1 1 0-1.5c1.428 0 2.486-1.06 2.486-2.25s-1.058-2.25-2.486-2.25",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.01 15.072c0-6.217 5.48-11.148 12.099-11.148 6.014 0 11.075 4.06 11.962 9.467a.75.75 0 1 1-1.48.243c-.755-4.6-5.117-8.21-10.482-8.21-5.917 0-10.6 4.38-10.6 9.648a8.93 8.93 0 0 0 1.308 4.646l.174.287-1.571 5.143a.1.1 0 0 0-.003.047.09.09 0 0 0 .057.06.06.06 0 0 0 .038-.002l5.51-1.71.263.122a11.4 11.4 0 0 0 4.824 1.055q.695 0 1.365-.079a.75.75 0 1 1 .175 1.49q-.758.09-1.54.09c-1.855 0-3.615-.386-5.19-1.075l-4.963 1.54c-1.22.378-2.338-.774-1.971-1.976l1.377-4.51a10.4 10.4 0 0 1-1.353-5.128",
    clipRule: "evenodd"
  }));
}
var IcFaqH32 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFaqH32));

export { IcFaqH32 as I };
